import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
import store from '@/store/store';
import {httpResource} from "@/resources/http.resource";
import {ISimilarNumbers} from "@/modules/barriers/interfaces/similar-numbers.interface";
import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";
import {bus} from "@/plugins/bus";

export class SimilarNumbers {
  async checkNumbers(barrier: Barrier.Entity) {
    const similarNumbers: ISimilarNumbers.IEntity[] = await this.getTableData(barrier);
    if (!similarNumbers) return;

    bus.$emit(Barrier.BusEvents.StopLoadingBarriers);

    if (!similarNumbers.length) {
      let payload: ICarStore.IPopupPayload = {
        carId: null,
        cashSum: barrier.tSum,
        cashParkId: barrier.parkId,
        createMode: true,
        presetFields: [
          { prop: 'carNumber', value: barrier.carNumber, },
        ],
        closeAction: async () => {
          bus.$emit(Barrier.BusEvents.RestartLoadBarriers);
        },
      };
      await store.dispatch('car/openCarPopup', payload);
    }
    else if (similarNumbers.length === 1) {
      await this.selectSimilarNumber(barrier, similarNumbers[0]);
    }
    else {
      await store.dispatch('dialog/openDialog', {
        blockName: 'barriers',
        dialogName: 'similarNumbers',
        payload: {
          similarNumbers,
          barrier,
          closeAction: () => {
            bus.$emit(Barrier.BusEvents.RestartLoadBarriers);
          },
        },
      });
    }
  }

  async getTableData(barrier: Barrier.Entity) {
    let asyncAction = async () => {
      const action = ISimilarNumbers.Action.SimilarNumbers;
      const params = {
        command: ISimilarNumbers.Command.Get,
        camId: barrier.camId,
        carNumber: barrier.carNumber,
        carId: barrier.carId,
      };
      const {data: {result: response}} = await httpResource.httpAction({action, params});
      const similarNumbers: ISimilarNumbers.IEntity[] = response.similarNumber;
      return similarNumbers;
    };

    const responseData = await store.dispatch('defaultResourceAction', { asyncAction });
    return responseData.success ? responseData.response : null;
  }

  async selectSimilarNumber(barrier: Barrier.Entity, similarNumber: ISimilarNumbers.IEntity) {
    let asyncAction = async () => {
      const action = ISimilarNumbers.Action.SimilarNumbers;
      const params = {
        command: ISimilarNumbers.Command.Set,
        camId: barrier.camId,
        carId: similarNumber.carId,
      } ;
      return await httpResource.httpAction({ action, params });
    };
    const { success } = await store.dispatch('defaultResourceAction', { asyncAction });
    if (success) {
      await store.dispatch('dialog/closeDialog', { blockName: 'barriers', dialogName: 'similarNumbers',});
      const payload: ICarStore.IPopupPayload = {
        carId: similarNumber.carId,
        closeAction: () => {
          bus.$emit(Barrier.BusEvents.RestartLoadBarriers);
        },
      };
      if (!similarNumber.carId) {
        payload.createMode = true;
        payload.presetFields = [
          { prop: 'carNumber', value: barrier.carNumber, },
        ];
      }
      await store.dispatch('car/openCarPopup', payload);
    }
  }
}

export const similarNumbers = new SimilarNumbers();